const teamData = [
    // {
    //     id: 1,
    //     name: "Abhishek Ranjan",
    //     profile: "Software Engineer",
    //     linkLink: "abhishek-ranjan-31105917a/",
    //     linkFace: "Abshek",
    //     offers: [
    //         "Amazon",
    //         "Harness",
    //         "MindTickle",
    //         "Dunzo"
    //     ]
    // },
    // {
    //     id: 2,
    //     name: "Adarsh",
    //     profile: "SDE II",
    //     linkLink: "adarsh-vakkaleri-sateesh-05576b55",
    //     linkFace: "",
    //     offers: [
    //         "Amazon Vancouver",
    //         "Goldman Sachs",
    //         "Directi"
    //     ]
    // }
    // {
    //     id: 3,
    //     name: "Sudipta Karmakar",
    //     profile: "Senior Software Engineer",
    //     linkLink: "sudiptakarmakar",
    //     linkFace: "",
    //     offers: [
    //         "Bloomberg",
    //         "AWS Seattle"
    //     ]
    // }
    {
        id:1,
        name:"JEFFERY BROWN",
        profile:"Creative leader",
        image:"https://images03.nicepage.com/c461c07a441a5d220e8feb1a/741ea998b40c562a812152bf/004.jpg"
    },
    {
        id:2,
        name:"ANN RICHMOND",
        profile:"Manager",
        image:"https://images03.nicepage.com/c461c07a441a5d220e8feb1a/df67a56b5e86559a887559d8/sssmin.jpg"
    },
    {
        id:1,
        name:"ALEX GREENFIELD", 
        profile:"Programing guru",
        image:"https://images03.nicepage.com/c461c07a441a5d220e8feb1a/f859b356bc085636a74efebd/3389.jpg"
    }
];

export default teamData;
